import Popover from '@mui/material/Popover';
import propTypes from 'prop-types';

export default function BasicPopover({ anchorEl, handleClose, children }) {
  return (
    <div>
      <Popover
        open={anchorEl}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
      >
        {children}
      </Popover>
    </div>
  );
}

BasicPopover.propTypes = {
  handleClose: propTypes.func,
  anchorEl: propTypes.any,
  children: propTypes.any
};
